import { useState } from "react";
import { motion } from "framer-motion";
import Sidebar from "../components/Sidebar";
import '../assets/css/themeSelector.css';
import { themeSelectorIcons } from '../assets/images/themeSelector';
import ThemesList from "../components/themes/ThemesList";
import SideCustomModal from "../components/themes/sideCustomModal";

export default function ThemeSelector() {
    const [searchQuery, setSearchQuery] = useState("");

    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedSubTheme, setSelectedSubTheme] = useState(null);
const role = localStorage.getItem("userRole");
const canCreateAccount = role === "ADMIN";

    const themes = [
        {
          name: "Business",
          subThemes: ["Entrepreneuriat", "Marketing", "Leadership", "Test 1", "Test2", "Test3", "Test 4"]
        },
        {
          name: "Professional Skills",
          subThemes: ["Investissement", "Cryptomonnaies", "Comptabilité"]
        },
        {
          name: "Practical and everyday life",
          subThemes: ["Tests A/B", "Tests Unitaires", "Tests de Performance"]
        }
    ];

    const filteredThemes = themes.filter((theme) => {
        const query = searchQuery.toLowerCase();
      
        // Vérifie le nom du thème
        const matchesThemeName = theme.name.toLowerCase().includes(query);
      
        // Vérifie si un sous-thème correspond
        const matchesSubTheme = theme.subThemes.some((sub) =>
          sub.toLowerCase().includes(query)
        );
      
        return matchesThemeName || matchesSubTheme;
      });

    return (
        <div className="page-container">
            <Sidebar />
            <div className="content-container">
                <div className="container-fluid">
                    <div className="userGreeting">
                        <span className="typoBlackStar">hello Firstname,</span><br />
                        <span>Lorem ipsum</span>
                    </div>
                    <div className="searchAndFilters mt-4">
                        <div className="search-bar">
                            <input 
                            type="text" 
                            className="searchInput" 
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <img src={themeSelectorIcons.search} className="solidinterfacesearch-icon" alt="Rechercher" />
                        </div>
                        <div className="filter-icons">
                            <div className="filter"></div>
                            <div className="random"></div>
                            <div className="save"></div>
                        </div>
                    </div>
                    {filteredThemes.length > 0 ? (
                        <ThemesList themes={filteredThemes}
                        searchQuery={searchQuery}
                        selectedTheme={selectedTheme}
                        setSelectedTheme={setSelectedTheme}
                        selectedSubTheme={selectedSubTheme}
                        setSelectedSubTheme={setSelectedSubTheme} />
                    ) : (
                        <motion.p 
                        className="no-result"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                        >
                            Aucun résultat trouvé
                        </motion.p>
                    )}
                </div>
            </div>
            <SideCustomModal setSelectedTheme={setSelectedTheme} selectedTheme={selectedTheme} setSelectedSubTheme={setSelectedSubTheme} selectedSubTheme={selectedSubTheme} />
        </div>
    );
}